import { createAction } from 'redux-actions';

export const NAMES = {
  SET: 'CLIENT.VIDEO.FULLSCREEN_STATUS.SET',
};

export const setFullScreenStatus = createAction(NAMES.SET);
